<template>
  <v-card v-if="!isLoading" class="elevation-0 mx-auto" max-width="550">
    <!-- title: system -->
    <Title :text="source.title" />
    <!-- content -->
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <ImageBox :options="source.items[1]" @action="handleImageAction" />
        </v-col>
        <v-col cols="12" md="6" class="">
          <ImageBox :options="source.items[2]" @action="handleImageAction" />

          <ImageBox
            class="mt-4"
            :options="source.items[3]"
            @action="handleImageAction"
          />
        </v-col>
      </v-row>
      <TextBox
        :isCanada="isCanada"
        :text="{
          ...source.textBox,
          paragraphHTML: settings[StylistsCertifications.FS_ONLINE]?.paragraph,
          buttonText: settings[StylistsCertifications.FS_ONLINE]?.buttonText,
          buttonLink: settings[StylistsCertifications.FS_ONLINE]?.buttonLink,
          secondaryButtonLink:
            settings[StylistsCertifications.FS_ONLINE]?.secondaryButtonLink,
          secondaryButtonText:
            settings[StylistsCertifications.FS_ONLINE]?.secondaryButtonText,
          showSecondaryButton:
            settings[StylistsCertifications.FS_ONLINE]?.showSecondaryButton
        }"
        :promo-price="settings[StylistsCertifications.FS_ONLINE]?.promoPrice"
        :list-price="settings[StylistsCertifications.FS_ONLINE]?.listPrice"
      />

      <v-divider class="my-5"></v-divider>

      <!-- apple style system accordion -->
      <v-expansion-panels flat>
        <v-expansion-panel>
          <v-expansion-panel-header
            class="text-h5 font-weight-bold breakword color-blue px-0"
          >
            <v-spacer></v-spacer>
            <span class="color-blue text-center font-weight-medium"
              >Why FreeStyler?</span
            >
            <v-spacer></v-spacer>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="accordion">
            <FreestylerView
              :source="stylistSoruces[SystemOptions.FREESTYLER]"
              :action="false"
              :certPage="StylistsCertifications.FS_ONLINE"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <CertPopUp
        :show="showPopUp"
        :options="options"
        @close="handleClosePopUp"
      />
    </v-card-text>
  </v-card>
</template>

<script>
  import { StylistsCertifications, SystemOptions } from '@/config/enums'
  import { mapActions } from 'vuex'
  import ImageBox from '../ImageBox.vue'
  import TextBox from '../TextBox.vue'
  import Title from '../Title.vue'
  import FreestylerView from '../stylists/FreestylerView.vue'
  import stylistSoruces from '../stylists/source-stylists'
  import CertPopUp from './CertPopUp.vue'

  const defaultOptions = {
    img: '',
    hasAction: false,
    video: '',
    popUpImg: '',
    text: '',
    popUpBtnText: ''
  }

  export default {
    components: {
      ImageBox,
      TextBox,
      Title,
      CertPopUp,
      FreestylerView
    },
    props: {
      source: {
        type: Object
      },
      isCanada: {
        type: Boolean
      }
    },
    data() {
      return {
        isLoading: true,
        StylistsCertifications,
        showPopUp: false,
        options: defaultOptions,
        stylistSoruces,
        SystemOptions
      }
    },
    computed: {
      settings() {
        if (this.isCanada) {
          return this.$store.getters.certificateSettingsCanada.settings
        }
        return this.$store.getters.certificateSettings.settings
      }
    },
    methods: {
      ...mapActions(['fetchSettings', 'editSettings']),
      handleImageAction(options) {
        this.options = options
        this.showPopUp = true
      },
      handleClosePopUp() {
        this.options = defaultOptions
        this.showPopUp = false
      },
      handleButtonClick() {
        this.$emit('btn-click')
      }
    },
    async created() {
      await this.fetchSettings()
      this.isLoading = false
    }
  }
</script>

<style scoped>
  .color-blue {
    color: #2179d2;
  }
  .accordion {
    margin-left: -48px;
    margin-right: -48px;
  }
</style>
